import styled, { css } from 'styled-components';
import { color } from '../../styles/mixins';

export const Tr = styled.tr<{ isActive?: boolean }>`
  ${(props) =>
    props.isActive &&
    css`
      background-color: ${color('green20')} !important;
      font-weight: 500;
    `}
`;
